//export const baseurl = "http://localhost:3001/api/v1"

export const baseurl = "https://www.otusone.com/api/v1"